import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { format, parseISO } from 'date-fns';
import { resolvePath } from '@/utils/resolvePath';
import { imageLoader } from '@/utils/imageLoader';
import { fetchVehicleInfo } from '@/components/fakeDoor/api';
import Router from '@/components/common/router';
import { trackEventAPI } from '@/analytics/middleware';
import { TAP_BTN_RESUME_BOOKING_MODAL } from '@/analytics/events';
import { APPOINTMENT_CARD_TYPE } from '@/constants/enums';
import { formatBookingDetails } from '@/components/fakeDoor/utils';
import { DO_MMM, REGULAR_TIME_FORMAT } from '@/constants/dateTime';
import RightArrowIcon from '@/assets/Icons/Arrow_right.svg';
import CalendarIcon from '@/assets/Icons/calendar.svg';
import TimeIcon from '@/assets/Icons/time.svg';
import SplitIcon from '@/assets/Icons/split.svg';
import {
    UserCardWrapper,
    UserCardContainer,
    VehicleCardDetailsWrapper,
    UserWelcomeHeadingWrapper,
    ContinueText,
    VehicleDetailsWrapper,
    VehicleDetailsContainer,
    VehicleDetailsTextContainer,
    VehicleImageContainer,
    VehicleName,
    VehicleNumber,
    ArrowIconWrapper,
    AppointmentDataTimeWrapper,
    AppointmentDataTimeContainer,
    CalenderIconContainer,
    TimeIconContainer,
    AppointmentDateTimeText,
    SplitIconContainer,
    UpcomingBookingContentWrapper,
} from './styles';
import { USER_CARD_MESSAGES } from './messages';

const UpcomingBookingCard = ({ cardData }: { cardData: any }) => {
    const [imageData, setImageData] = useState('');
    const { navigatePath, paymentLink } = cardData;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const visData = await fetchVehicleInfo(
                    cardData?.vehicleDetails?.model_id as number
                );
                setImageData(JSON.parse(visData));
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if (cardData?.vehicleDetails?.model_id) {
            fetchData();
        }
    }, [cardData?.vehicleDetails?.model_id]);

    const handleClick = () => {
        trackEventAPI({
            event_name: TAP_BTN_RESUME_BOOKING_MODAL,
            customAttributes: {
                model_id: cardData?.vehicleDetails?.model_id,
                vehicle_make: cardData?.vehicleDetails?.make,
                vehicle_model: cardData?.vehicleDetails?.model,
                variant: cardData?.vehicleDetails?.variant_name,
                fuel_type:
                    cardData?.vehicleDetails?.fuel_type?.toLocaleUpperCase(),
                ...formatBookingDetails(cardData?.booking),
            },
            isFakeDoor: true,
        });

        if (cardData.cardType === APPOINTMENT_CARD_TYPE.CONTACT_US) {
            window.open(navigatePath, '_self');
        } else {
            if (paymentLink) {
                window.location.href = paymentLink;
            } else {
                Router.push(navigatePath);
            }
        }
    };

    const appointmentDate =
        cardData?.booking?.booking_details?.appointment_date;

    let formattedDay = '';
    if (appointmentDate) {
        try {
            const date = parseISO(appointmentDate.replace(' ', 'T'));
            formattedDay = format(date, DO_MMM);
        } catch {
            try {
                const date = new Date(appointmentDate);
                formattedDay = format(date, DO_MMM);
            } catch {
                formattedDay = '';
            }
        }
    }

    let formattedTime = '';
    if (appointmentDate) {
        try {
            const date = parseISO(appointmentDate.replace(' ', 'T'));
            formattedTime = format(date, REGULAR_TIME_FORMAT);
        } catch {
            try {
                const date = new Date(appointmentDate);
                formattedTime = format(date, REGULAR_TIME_FORMAT);
            } catch {
                formattedTime = '';
            }
        }
    }

    return (
        <UserCardWrapper>
            <UserWelcomeHeadingWrapper>
                <ContinueText>
                    {USER_CARD_MESSAGES.UPCOMING_BOOKING_TITLE}
                </ContinueText>
            </UserWelcomeHeadingWrapper>
            <UserCardContainer onClick={handleClick}>
                <UpcomingBookingContentWrapper>
                    <AppointmentDataTimeWrapper>
                        {/* <AppointmentDataTimeContainer> */}
                        <CalenderIconContainer>
                            <CalendarIcon />
                        </CalenderIconContainer>
                        <AppointmentDateTimeText>
                            {formattedDay}
                        </AppointmentDateTimeText>
                        {/* </AppointmentDataTimeContainer> */}
                        <SplitIconContainer>
                            <SplitIcon />
                        </SplitIconContainer>
                        {/* <AppointmentDataTimeContainer> */}
                        <TimeIconContainer>
                            <TimeIcon />
                        </TimeIconContainer>
                        <AppointmentDateTimeText>
                            {formattedTime}
                        </AppointmentDateTimeText>
                        {/* </AppointmentDataTimeContainer> */}
                    </AppointmentDataTimeWrapper>
                    {/* <UserCardContainer onClick={handleClick}> */}
                    <VehicleCardDetailsWrapper isUpcomingBooking={true}>
                        <VehicleDetailsWrapper>
                            <VehicleImageContainer>
                                <Image
                                    loader={imageLoader}
                                    src={
                                        imageData ||
                                        resolvePath(
                                            USER_CARD_MESSAGES.DEFAULT_CAR_IMAGE
                                        )
                                    }
                                    width={114}
                                    height={66}
                                    alt={USER_CARD_MESSAGES.CAR_IMAGE_ALT}
                                />
                            </VehicleImageContainer>
                            <VehicleDetailsContainer>
                                <VehicleDetailsTextContainer>
                                    <VehicleName>
                                        {cardData?.vehicleDetails?.make}{' '}
                                        {cardData?.vehicleDetails?.model}
                                    </VehicleName>
                                    <VehicleNumber>
                                        {
                                            cardData?.vehicleDetails
                                                ?.registration_number
                                        }
                                    </VehicleNumber>
                                </VehicleDetailsTextContainer>

                                <ArrowIconWrapper>
                                    <RightArrowIcon />
                                </ArrowIconWrapper>
                            </VehicleDetailsContainer>
                        </VehicleDetailsWrapper>
                    </VehicleCardDetailsWrapper>
                    {/* </UserCardContainer> */}
                </UpcomingBookingContentWrapper>
            </UserCardContainer>
        </UserCardWrapper>
    );
};

export default UpcomingBookingCard;
